import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c195752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-link layout-topbar-menu-button layout-topbar-button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "layout-topbar-menu hidden lg:flex origin-top" }
const _hoisted_7 = {
  style: {"margin-left":"2rem"},
  class: "user-name"
}
const _hoisted_8 = { class: "field" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}

import i18n from '@/locale/i18n';
import { onMounted, ref, watch } from 'vue';
import router from '@/router';
import { useToast } from 'primevue/usetoast';
import { useRoute } from 'vue-router';
import { ToastControl } from './utils/ToastControl';
import Echo from 'laravel-echo';
import { IMenus } from '@/interface/serverData/common/i-menus';

import { useAuthStore } from '@/store/auth';
import { useHolidayStore } from '@/store/common/holidayStore';

import { IChangePWDComponent } from '@/interface/component/common/i-change-pwd-component';
import { IStoreComponent } from '@/interface/component/master/i-store-component';
import { IHolidayComponent } from "@/interface/component/master/i-holiday-component";
import { IUserInfoComponent } from '@/interface/component/master/i-user-component';
import { ICountryComponent } from '@/interface/component/registration/i-registration-component';
import { IRankComponent } from '@/interface/component/master/i-rank-component';

import { RoleConfig } from '@/configs/role-config';

import AuthService from '@/service/auth/AuthService';
import UserService from '@/service/master/UserService';
import StoreService from '@/service//master/StoreService';
import HolidayService from "@/service/master/HolidayService";
import RegistrationService from '@/service/registration/RegistrationService';
import RankService from '@/service/master/RankService';

import { usePurposeStore } from '@/store/registration/purposeStore';
import { useSalesRouteStore } from '@/store/registration/salesRouteStore';
import { useChildFeeStore } from '@/store/common/childFeeStore';
import { useFreeMemoStore } from '@/store/common/freeMemoStore';
import { useRoomTypeStore } from '@/store/common/roomTypeStore';
import { useCountryStore } from '@/store/common/countryStore';
import { usePrefectureStore } from '@/store/common/prefectureStore';
import { useRankStore } from '@/store/common/rankStore';







export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenuTopBar',
  setup(__props) {

const t = i18n.global.t;
const route = useRoute();
const userStore = useAuthStore();
const authService = ref(new AuthService());
const userService = ref(new UserService());
const displayFlag = ref(false);
const toast = useToast();

const pwd1 = ref('');
const pwd2 = ref('');
const userStoreId = ref(userStore!.targetStore!.storeId);
const lastStoreId = ref(userStore!.targetStore!.storeId);

const store = ref<IStoreComponent>();
const storeService = new StoreService();
const registrationService = ref(new RegistrationService());
const rankService = ref(new RankService());

const topbarImage = () => {
    // return 'images/logo_horizontal.png';
    return 'images/logo_horizontal.svg';
}

const holidayStore = useHolidayStore();
const holidayService = ref(new HolidayService());

const freeMemoStore = useFreeMemoStore();
const salesRouteStore = useSalesRouteStore();
const purposeStore = usePurposeStore();
const roomTypeStore = useRoomTypeStore();
const childFeeStore = useChildFeeStore();

const countryStore = useCountryStore();
const prefectureStore = usePrefectureStore();
const rankStore = useRankStore();

// const billingAddressStore = useBillingAddressStore();
// const accountingItemStore = useAccountingItemStore();
// const registrationSettlementDialogStore = useRegistrationSettlementDialogStore();
// const registrationReceiptDetailDialogStore = useRegistrationReceiptDetailDialogStore();


const requestGetStoreInformation = () => {
    return new Promise((resolve, reject) => {
        storeService.show(userStore.targetStore!)
            .then(async (response) => {
                resolve(response);
            })
            .catch((response) => {
                reject(response);
            });
    });
}

const requestGetHolidays = () => {
    return new Promise((resolve, reject) => {
        holidayService.value.list()
            .then(async (response) => {
                resolve(response);
            })
            .catch((response) => {
                reject(response);
            });
    });
}

const requestChangeStore = (userId: number, storeId: number) => {
    return new Promise((resolve, reject) => {
        userService.value.changeCurrentStore(
            userId,
            storeId
        )
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const requestCountry = () => {
    return new Promise((resolve, reject) => {
        registrationService.value.getDropdownCountry()
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const requestPrefectures = () => {
    return new Promise((resolve, reject) => {
        registrationService.value.getDropdownPrefectures()
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const requestRankTypes = () => {
    return new Promise((resolve, reject) => {
        rankService.value.getDropDownList()
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}


onMounted(async () => {
    registerWSListener();

    // ログインした後、休みの日を取得して、piniaに保存
    
    console.log('app menu onMounted start')

    if (userStore.currentStoreInformation === null || userStore.currentStoreInformation === undefined) {
        console.log('refresh store info and holiday');
        userStore.showSpinner();

        await Promise.all([
            requestGetStoreInformation(),
            requestGetHolidays(),
            requestCountry(),
            requestPrefectures(),
            requestRankTypes()
        ])
        .then((responses) => {
            // getStoreInformation res
            if (responses.length == 5) {
                const storeInfo = responses[0] as IStoreComponent;
                userStore.currentStoreInformation = storeInfo;

                const holidays = responses[1] as IHolidayComponent[];
                holidayStore.holidays = holidays;

                const country = responses[2] as ICountryComponent[];
                countryStore.countries = country;

                const prefectures = responses[3] as ICountryComponent[];
                prefectureStore.prefectures = prefectures;

                const ranks = responses[4] as IRankComponent[];
                rankStore.ranks = ranks;
                
            } else {
                toast.add(ToastControl.ErrorMessageWithSystemError());
            }
        })
        .catch((response) => {
            if (response!.returnCode!.substring(0, 3) === 'HOS') {
                toast.add(ToastControl.ErrorMessage(response.message));
            } else {
                toast.add(ToastControl.ErrorMessageWithSystemError());
            }
        })
        .finally(() => {
            console.log('app menu final')
            userStore.hideSpinner();
        })
    }
    console.log('app menu onMounted end')
})

const menusSection = (SECTION: string) => {
    let SECTION0: any[] = [];
    userStore.menus!.forEach(menu => {
        if (menu.section === SECTION) {
            SECTION0.push(menu);
        }
    })
    labelTransform(SECTION0);
    if (SECTION === 'SECTION03') {
        SECTION0.push({
            icon: 'pi pi-fw pi-user-edit', label: 'パスワード変更', command: () => {

                // Show spinner
                userStore.showSpinner();

                storeService.show(userStore.targetStore!)
                    .then(data => {
                        store.value = data as IStoreComponent;

                        displayFlag.value = true;
                    })
                    .catch(response => {
                        toast.add(ToastControl.ErrorMessage(response!.data!.message));
                    })
                    .finally(() => {
                        // Hide spinner
                        userStore.hideSpinner();
                    });
            }
        });
        SECTION0.push({
            icon: 'pi pi-fw pi-sign-out', label: 'ログアウト', command: () => {
                authService.value.logout();
                router.push('/login')

                setTimeout(() => {
                    console.log('logout')
                    unregisterAllWSChannel();
                    userStore.setDefaultState();

                    holidayStore.$reset();
                    countryStore.$reset();
                    prefectureStore.$reset();
                    rankStore.$reset();

                    // freeMemoStore.$reset();
                    // salesRouteStore.$reset();
                    // purposeStore.$reset();
                    // roomTypeStore.$reset();
                    // childFeeStore.$reset();

                    console.log(userStore);
                }, 200)
            }
        });
    }
    return SECTION0;
}

const labelTransform = (menus: any[]) => {
    menus.forEach(menu => {
        menu.label = t(`${menu.label}`);
        if (menu.items) {
            labelTransform(menu.items);
        }
    })
}


const storeChange = async () => {
    if (userStoreId.value && lastStoreId.value !== userStoreId.value) {
        userStore!.user!.userStores.forEach(store => {
            if (store.storeId === userStoreId.value) {
                userStore!.user!.storeName = store.name;
            }
        })
        userStore!.user!.storeId = userStoreId.value;
        userStore!.targetStore!.storeId = userStoreId.value;


        userStore.showSpinner();

        console.log('change store start')

        await Promise.all([
            requestChangeStore(userStore.loggedUser!.userId, userStoreId.value),
            requestGetStoreInformation(),
            requestGetHolidays()
        ])
        .then((responses) => {
            // getStoreInformation res
            if (responses.length == 3) {

                // requestChangeStore response
                const data = responses[0] as IUserInfoComponent;
                unregisterAllWSChannel();

                userStore.bussinessDate = data.businessDate;
                userStore.salesDate = data.salesDate;

                userStore.targetStore = {
                    groupId: data.groupId,
                    companyId: data.companyId,
                    storeId: data.storeId,
                };

                userStore.user!.storeId = data.storeId;

                const userMenus = data.menus;
                userStore.menus = userMenus;

                lastStoreId.value = userStoreId.value;

                registerWSListener();

                // requestGetStoreInformation response
                const storeInfo = responses[1] as IStoreComponent;

                userStore.currentStoreInformation = storeInfo;

                // requestGetHolidays response
                const holidays = responses[2] as IHolidayComponent[];

                holidayStore.holidays = holidays;
            } else {
                toast.add(ToastControl.ErrorMessageWithSystemError());
            }
        })
        .catch((response) => {
            if (response!.returnCode!.substring(0, 3) === 'HOS') {
                toast.add(ToastControl.ErrorMessage(response.message));
            } else {
                toast.add(ToastControl.ErrorMessageWithSystemError());
            }
        })
        .finally(() => {
            console.log('change store end')
            userStore.hideSpinner();

            countryStore.$reset();
            prefectureStore.$reset();
            rankStore.$reset();

            // freeMemoStore.$reset();
            // salesRouteStore.$reset();
            // purposeStore.$reset();
            // roomTypeStore.$reset();
            // childFeeStore.$reset();

            setTimeout(() => {
                router.push('/?v=' + Math.random());
            }, 300)
        })
    }
}
const menu1 = ref();
const menu2 = ref();
const displayMenu1 = ref('display:none');
const displayMenu2 = ref('display:none');

const toggle = (event: any, id: string) => {
    if (id === '1') {
        displayMenu1.value = 'display:block';
        displayMenu2.value = 'display:none';
    } else {
        displayMenu2.value = 'display:block';
        displayMenu1.value = 'display:none';
    }
}

const btnBlur = (event: any, id: string) => {
    setTimeout(() => {
        if (id === '1') {
            displayMenu1.value = 'display:none';
        } else {
            displayMenu2.value = 'display:none';
        }

    }, 200);
}

watch(() => route.fullPath, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        displayMenu1.value = 'display:none';
        displayMenu2.value = 'display:none';
    }
})

const inputCheck = ref(false);
const verifyPWD = ref(false);
const passwordFlag = ref(false);

const passwordValidErrorMesage = ref('');

const onSaveClick = () => {

    // HOTELOS_DEV-617 start
    function isPasswordValid(password: string, passwordPattern: string, passwordMinLength: number): boolean {
        const hasNumber = /\d/.test(password);
        const hasLetter = /[a-zA-Z]/.test(password);

        if (passwordPattern === 'AN') {
            return hasNumber && hasLetter && password.length >= passwordMinLength;
        } else if (passwordPattern === 'A') {
            return hasLetter && password.length >= passwordMinLength;
        } else if (passwordPattern === 'N') {
            return hasNumber && password.length >= passwordMinLength;
        }

        return false;
    }


    verifyPWD.value = false;
    inputCheck.value = false;
    passwordFlag.value = false;


    if (!(isPasswordValid(pwd1.value, store.value!.storeSetting!.passwordPattern, store.value!.storeSetting!.passwordMinLength))) {
        inputCheck.value = true;
        passwordFlag.value = true;

        let msgKey = 'HOS-05019-0-1';

        if (store.value!.storeSetting!.passwordPattern === 'AN') {
            msgKey = 'HOS-05019-0-1';
        } else if (store.value!.storeSetting!.passwordPattern === 'A') {
            msgKey = 'HOS-05019-0-2';
        } else if (store.value!.storeSetting!.passwordPattern === 'N') {
            msgKey = 'HOS-05019-0-3';
        }

        const p1 = t('ERROR_MESSAGE.'+msgKey);

        passwordValidErrorMesage.value = t("ERROR_MESSAGE.HOS-05019-0", [store.value!.storeSetting!.passwordMinLength, p1])

        return;
    }
    // HOTELOS_DEV-617 end

    let verify = false;
    if (pwd1.value && pwd2.value) {
        if (pwd1.value === pwd2.value) {
            verify = true;
        }
    }
    if (!verify) {
        verifyPWD.value = true;
        return;
    }

    // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6}$/;
    // if (!reg.test(pwd2.value)) {
    //     passwordFlag.value = true;
    //     return;
    // }
    const data = {
        password: pwd2.value,
        userId: userStore.user?.userId ?? ''
    } as IChangePWDComponent;
    userStore.showSpinner();
    userService.value.changePassword(userStore.targetStore!, data)
        .then(data => {
            data as any;
            toast.add(ToastControl.SuccessMessageWithUpdateSuccessful());
            displayFlag.value = false;
            // authService.value.logout();
            // router.push('/login');
        })
        .catch(response => {
            if (response!.data!.return_code!.substring(0, 3) === 'HOS') {
                toast.add(ToastControl.ErrorMessage(response!.data!.message));
            } else {
                toast.add(ToastControl.ErrorMessageWithSystemError());
            }
        })
        .finally(() => {
            // Hide spinner
            userStore.hideSpinner();
        });
}

const dialogHide = () => {
    pwd1.value = '';
    pwd2.value = '';
    verifyPWD.value = false;
    inputCheck.value = false;
}

const passwordFocusRef = ref();

const pwdDialogShow = () => {
    passwordFocusRef.value.$el.children[0].focus();
}

const laravelEcho = ref();

const registerWSListener = () => {
    //Only user logged in the ws channel could be created
    if (userStore.user) {
        if (laravelEcho.value) {
            laravelEcho.value.leaveAllChannels();
        }
        const pusher = require('pusher-js');
        laravelEcho.value = new Echo({
            broadcaster: process.env.VUE_APP_LARAVAL_ECHO_BROADCASTER,
            key: process.env.VUE_APP_LARAVAL_ECHO_KEY,
            cluster: process.env.VUE_APP_LARAVAL_ECHO_CLUSTER,
            wsHost: process.env.VUE_APP_LARAVAL_ECHO_WS_HOST,
            wsPort: Number(process.env.VUE_APP_LARAVAL_ECHO_WS_PORT),
            forceTLS: Boolean(process.env.VUE_APP_LARAVAL_ECHO_FORCE_TLS == 'true'),
            disableStats: Boolean(process.env.VUE_APP_LARAVAL_ECHO_DISABLE_STATS == 'true'),
            authEndpoint: process.env.VUE_APP_LARAVAL_ECHO_AUTH_END_POINT,
            auth: {
                headers: {
                    Authorization: 'Bearer ' + userStore.user.tokenVal, //Bearer is the prefix
                },
            },
        });
        const channelName = `${process.env.VUE_APP_LARAVAL_ECHO_EVENT_PREFIX}.${userStore.user.groupId}.${userStore.user.companyId}.${userStore.user.storeId}`;

        //listen the business date updated event.
        laravelEcho.value!.private(channelName).listen('BusinessDateUpdated', (d: any) => {
            console.log('BUSINESSDATEUPDATED:', d.businessDate);
            userStore.bussinessDate = d.businessDate;
        });
    }
}

const unregisterAllWSChannel = () => {
    if (laravelEcho.value) {
        laravelEcho.value.leaveAllChannels();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_XDropdown = _resolveComponent("XDropdown")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_XTitleLabel = _resolveComponent("XTitleLabel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_styleclass = _resolveDirective("styleclass")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menubar, {
      model: menusSection('SECTION01')
    }, {
      start: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: "/",
          class: "layout-topbar-logo"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "Logo",
              src: topbarImage()
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        })
      ]),
      end: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_3, _hoisted_5)), [
          [_directive_styleclass, {
                    selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
                    leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true
                }]
        ]),
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, [
            _createVNode(_component_Inplace, {
              closable: true,
              class: "user-name store-name",
              onClose: storeChange
            }, {
              display: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(userStore)!.user!.storeName), 1)
              ]),
              content: _withCtx(() => [
                _createVNode(_component_XDropdown, {
                  modelValue: userStoreId.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userStoreId).value = $event)),
                  options: _unref(userStore)!.user!.userStores,
                  optionLabel: "name",
                  optionValue: "storeId"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Button, {
              style: {"margin-left":"2rem","color":"#fff"},
              icon: "pi pi-cog",
              class: "p-button-rounded p-button-text",
              onClick: _cache[1] || (_cache[1] = (event) => toggle(event, '1')),
              onBlur: _cache[2] || (_cache[2] = (event) => btnBlur(event, '1'))
            }),
            _createVNode(_component_Menu, {
              class: "menu",
              id: "overlay_tmenu1",
              ref_key: "menu1",
              ref: menu1,
              model: menusSection('SECTION02'),
              style: _normalizeStyle(displayMenu1.value)
            }, null, 8, ["model", "style"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Button, {
              style: {"margin-left":"2rem","color":"#fff"},
              icon: "pi pi-user",
              class: "p-button-rounded p-button-text",
              onClick: _cache[3] || (_cache[3] = (event) => toggle(event, '2')),
              onBlur: _cache[4] || (_cache[4] = (event) => btnBlur(event, '2'))
            }),
            _createVNode(_component_Menu, {
              class: "menu",
              id: "overlay_tmenu2",
              ref_key: "menu2",
              ref: menu2,
              model: menusSection('SECTION03'),
              style: _normalizeStyle(displayMenu2.value)
            }, null, 8, ["model", "style"])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_7, _toDisplayString('業務日付  ：'+_unref(userStore)!.bussinessDate), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_Dialog, {
      header: _unref(t)('DIALOG.TOP_MENU_PWD_CONFIRM'),
      visible: displayFlag.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((displayFlag).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '400px' },
      class: "p-fluid input-top",
      onShow: pwdDialogShow,
      onHide: dialogHide,
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _unref(t)('COMMON.BUTTON.SAVE'),
          class: "p-button-success",
          icon: "pi pi-check",
          onClick: onSaveClick
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_XTitleLabel, {
            for: "submitPassword1",
            title: _unref(t)('DIALOG.TOP_MENU_PWD')
          }, null, 8, ["title"]),
          _createVNode(_component_Password, {
            ref_key: "passwordFocusRef",
            ref: passwordFocusRef,
            id: "submitPassword1",
            placeholder: _unref(t)("FORGET.PASSWORD_PLACEHOLDER"),
            feedback: false,
            toggleMask: true,
            modelValue: pwd1.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pwd1).value = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["placeholder", "modelValue"]),
          (passwordFlag.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(passwordValidErrorMesage.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_XTitleLabel, {
            for: "submitPassword2",
            title: _unref(t)('DIALOG.TOP_MENU_PWD_SECOND')
          }, null, 8, ["title"]),
          _createVNode(_component_Password, {
            id: "submitPassword2",
            placeholder: _unref(t)("FORGET.PASSWORD_PLACEHOLDER"),
            feedback: false,
            toggleMask: true,
            modelValue: pwd2.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((pwd2).value = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["placeholder", "modelValue"]),
          (verifyPWD.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_unref(t)("DIALOG.TOP_MENU_PWD_VERIFY")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ]))
}
}

})